(function () {
  if (window.__kokootPdpEnhancementsLoaded) return;
  window.__kokootPdpEnhancementsLoaded = true;

  const MEDIA_JSON_SELECTOR = 'script[id^="KokootPdpVariantMedia-"]';
  const META_JSON_SELECTOR = 'script[id^="KokootPdpVariantMeta"]';
  const RELATED_SELECTOR = '[id$="__product_list_related"]';
  const VARIANT_LABEL_SELECTOR = '.product-details .variant-option__button-label';
  const VARIANT_INTERACTION_SELECTOR =
    '.product-details .variant-option__button-label, .product-details .variant-option input[type="radio"]';

  // Option names (lower-cased) that should ALWAYS render as plain text buttons (never image swatches),
  // even when their variants carry images. Everything else defaults to image-swatch behaviour.
  const TEXT_OPTION_NAMES = [
    'size', 'sizes', '尺寸', '尺码', '大小',
    'capacity', '容量',
    'length', '长度', '長度',
    'weight', '重量',
    'age', '年龄', '年齡',
  ];
  const COLOR_OPTION_NAMES = ['color', 'colour', '颜色', '顏色', '颜色分类', '顏色分類'];
  const COLOR_WORDS = new Set([
    'black', 'white', 'cream', 'beige', 'brown', 'caramel', 'tan', 'khaki', 'coffee',
    'gray', 'grey', 'silver', 'gold', 'green', 'blue', 'navy', 'red', 'pink', 'rose',
    'purple', 'violet', 'yellow', 'orange', 'coral', 'mint', 'olive', 'ivory', 'milk', 'tea',
    'light', 'dark', 'deep', 'pale', 'sky', 'moss',
    'transparent', 'clear', 'rainbow',
    '黑', '白', '米', '奶', '茶', '棕', '咖', '灰', '银', '銀', '金', '绿', '綠',
    '蓝', '藍', '红', '紅', '粉', '紫', '黄', '黃', '橙', '透明', '彩虹',
  ]);
  const COLOR_REJECT_WORDS = [
    'florida', 'sunrise', 'series', 'style', 'styles', 'set', 'pack', 'pattern', 'print',
    'waist', 'crossbody', 'harness', 'leash', 'coconut', 'palm', 'island', 'adventure',
    'pro', 'classic', 'holiday', 'christmas', 'basketball', 'football', 'baseball',
  ];
  const SOLID_COLOR_MAP = new Map([
    ['black', '#111111'], ['white', '#ffffff'], ['cream', '#f4ead8'], ['beige', '#d8c2a5'],
    ['brown', '#7a4a2a'], ['caramel', '#b97945'], ['tan', '#c8a47a'], ['khaki', '#b8aa7c'],
    ['coffee', '#6f4a34'], ['gray', '#8d8d8d'], ['grey', '#8d8d8d'], ['silver', '#c8c8c8'],
    ['gold', '#d8a83f'], ['green', '#4f8f57'], ['olive', '#788c52'], ['blue', '#3478c6'], ['navy', '#0b234f'],
    ['red', '#d84835'], ['pink', '#ee8db3'], ['rose', '#d36b88'], ['purple', '#8d64c2'],
    ['violet', '#8063b6'], ['yellow', '#f3c84a'], ['orange', '#ff6b35'], ['coral', '#ff7a5a'],
    ['mint', '#93d7c2'], ['ivory', '#f7f1df'],
    ['黑', '#111111'], ['白', '#ffffff'], ['米', '#f4ead8'], ['奶', '#f4ead8'],
    ['茶', '#b97945'], ['棕', '#7a4a2a'], ['咖', '#6f4a34'], ['灰', '#8d8d8d'],
    ['银', '#c8c8c8'], ['銀', '#c8c8c8'], ['金', '#d8a83f'], ['绿', '#4f8f57'],
    ['綠', '#4f8f57'], ['蓝', '#3478c6'], ['藍', '#3478c6'], ['红', '#d84835'],
    ['紅', '#d84835'], ['粉', '#ee8db3'], ['紫', '#8d64c2'], ['黄', '#f3c84a'],
    ['黃', '#f3c84a'], ['橙', '#ff6b35'],
  ]);

  let runQueued = false;
  let mediaCacheKey = '';
  let mediaCache = { byId: new Map(), byValue: new Map(), byValueImage: new Map(), items: [] };
  let metaCacheKey = '';
  let metaCache = { optionNames: [], productImage: null, colorPatternIds: null };
  // Guard so the Color->Size auto-correct fires once per invalid state, not on every burst pass.
  let autoSelectPending = false;
  let autoSelectTimer = 0;
  const galleryProgressTimers = new WeakMap();

  function parseVariantMedia() {
    const scripts = Array.from(document.querySelectorAll(MEDIA_JSON_SELECTOR));
    const cacheKey = scripts.map((script) => `${script.id}:${script.textContent?.length || 0}`).join('|');

    if (cacheKey && cacheKey === mediaCacheKey) {
      return mediaCache;
    }

    const byId = new Map();
    const byValue = new Map();
    const byValueImage = new Map();
    const items = [];

    scripts.forEach((script) => {
      try {
        const parsed = JSON.parse(script.textContent || '[]');
        parsed.forEach((item) => {
          if (!item) return;
          items.push(item);
          if (item.id) byId.set(String(item.id), item);
          (item.options || []).forEach((value) => {
            if (!byValue.has(value)) byValue.set(value, item);
            // first variant that actually HAS an image for this option value (image fallback within value)
            if (item.image && !byValueImage.has(value)) byValueImage.set(value, item);
          });
        });
      } catch (error) {
        console.warn('[kokoot] Unable to parse variant media map', error);
      }
    });

    mediaCacheKey = cacheKey;
    mediaCache = { byId, byValue, byValueImage, items };
    return mediaCache;
  }

  function parseVariantMeta() {
    const script = document.querySelector(META_JSON_SELECTOR);
    const cacheKey = script ? `${script.id}:${script.textContent?.length || 0}` : '';
    if (cacheKey && cacheKey === metaCacheKey) return metaCache;
    let optionNames = [];
    let productImage = null;
    let colorPatternIds = null;
    if (script) {
      try {
        const parsed = JSON.parse(script.textContent || '{}');
        if (Array.isArray(parsed.optionNames)) optionNames = parsed.optionNames;
        if (parsed.productImage) productImage = parsed.productImage;
        if (Object.prototype.hasOwnProperty.call(parsed, 'colorPatternIds')) {
          colorPatternIds = Array.isArray(parsed.colorPatternIds) ? parsed.colorPatternIds : [];
        }
      } catch (error) {
        console.warn('[kokoot] Unable to parse variant meta', error);
      }
    }
    metaCacheKey = cacheKey;
    metaCache = { optionNames, productImage, colorPatternIds };
    return metaCache;
  }

  // The displayed value string of a single option button (matches variant.options[] strings).
  function valueOfLabel(label) {
    const input = label.querySelector('input[type="radio"]');
    const textEl = label.querySelector('.variant-option__button-label__text');
    return (
      (input && input.value) ||
      (input && input.getAttribute('aria-label')) ||
      label.getAttribute('title') ||
      (textEl && textEl.textContent.trim()) ||
      label.textContent.trim()
    );
  }

  // Option name for a fieldset: prefer the server-provided list (mapped by data-fieldset-index),
  // fall back to the first text node of the <legend> (the option label, before the selected-value span).
  function optionNameFor(fieldset, optionNames) {
    const idx = fieldset.dataset.fieldsetIndex != null ? parseInt(fieldset.dataset.fieldsetIndex, 10) : -1;
    if (idx >= 0 && optionNames && optionNames[idx]) return optionNames[idx];
    const legend = fieldset.querySelector('legend');
    if (legend) {
      for (const node of legend.childNodes) {
        if (node.nodeType === 3 && node.textContent.trim()) return node.textContent.trim();
      }
      return (legend.textContent || '').trim();
    }
    return '';
  }

  function isTextOption(name) {
    return TEXT_OPTION_NAMES.includes((name || '').trim().toLowerCase());
  }

  function isColorOption(name) {
    const lower = (name || '').trim().toLowerCase();
    return (
      COLOR_OPTION_NAMES.includes(lower) ||
      lower.startsWith('color') ||
      lower.startsWith('colour') ||
      lower.startsWith('颜色') ||
      lower.startsWith('顏色')
    );
  }

  function normalizeColorValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[()[\]{}]/g, ' ')
      .replace(/[\/_+&,|]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function colorTokens(value) {
    const normalized = normalizeColorValue(value);
    if (!normalized) return [];
    return normalized.split(/[\s-]+/).filter(Boolean);
  }

  function isPureColorValue(value) {
    const normalized = normalizeColorValue(value);
    if (!normalized) return false;
    if (COLOR_REJECT_WORDS.some((word) => normalized.includes(word))) return false;
    const tokens = colorTokens(value);
    if (!tokens.length || tokens.length > 5) return false;
    return tokens.every((token) => COLOR_WORDS.has(token) || /^\d+$/.test(token));
  }

  function colorForValue(value) {
    const tokens = colorTokens(value);
    for (const token of tokens) {
      if (SOLID_COLOR_MAP.has(token)) return SOLID_COLOR_MAP.get(token);
    }
    return null;
  }

  function optionValues(fieldset) {
    return Array.from(fieldset.querySelectorAll('.variant-option__button-label')).map(valueOfLabel);
  }

  function shouldUseTextButtons(optionName, values, hasProductColorPattern) {
    if (isTextOption(optionName)) return true;
    if (!isColorOption(optionName)) return false;
    if (!hasProductColorPattern) return true;
    return values.some((value) => !isPureColorValue(value));
  }

  function decorateVariantButtons() {
    const { byId, byValue, byValueImage } = parseVariantMedia();
    const { optionNames, productImage, colorPatternIds } = parseVariantMeta();
    const colorPatternKnown = Array.isArray(colorPatternIds);
    const hasProductColorPattern = colorPatternKnown ? colorPatternIds.length > 0 : true;

    document.querySelectorAll('.product-details .variant-option').forEach((fieldset) => {
      const labels = fieldset.querySelectorAll('.variant-option__button-label');
      if (!labels.length) return;

      const optionName = optionNameFor(fieldset, optionNames);
      const values = optionValues(fieldset);
      const textOption = shouldUseTextButtons(optionName, values, hasProductColorPattern);
      const colorTextOption = isColorOption(optionName) && textOption;
      fieldset.classList.toggle('kokoot-opt-text', textOption);
      fieldset.classList.toggle('kokoot-opt-media', !textOption);
      fieldset.classList.toggle('kokoot-opt-color-text', colorTextOption);

      labels.forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        if (!input) return;

        const value =
          (input.value || input.getAttribute('aria-label') || label.getAttribute('title') || valueOfLabel(label));

        label.classList.add('kokoot-variant-chip');
        label.classList.remove('kokoot-variant-chip--media', 'kokoot-variant-chip--text', 'kokoot-variant-chip--solid');
        label.setAttribute('title', value);
        label.style.removeProperty('--kokoot-variant-color');

        // Text-type option (e.g. Size): force plain text button, strip any previously injected swatch.
        if (textOption) {
          label.classList.add('kokoot-variant-chip--text');
          label.style.removeProperty('--kokoot-variant-image');
          const stale = label.querySelector('.kokoot-variant-chip__image');
          if (stale) stale.remove();
          return;
        }

        // Image-type option (e.g. Color): resolve image with fallback chain so a SKU without its own
        // featured_image never degrades into a long-text box:
        //   variant.featured_image -> another variant sharing this value that has an image -> product image
        const variantId = input.dataset.variantId;
        const item = byId.get(String(variantId)) || byValue.get(value);
        const valueImage = byValueImage.get(value);
        const pureColor = isColorOption(optionName) && hasProductColorPattern && isPureColorValue(value);
        const image = (item && item.image) || (valueImage && valueImage.image) || (!pureColor ? productImage : null);

        if (!image && pureColor) {
          const solidColor = colorForValue(value);
          if (solidColor) {
            label.classList.add('kokoot-variant-chip--media', 'kokoot-variant-chip--solid');
            label.style.removeProperty('--kokoot-variant-image');
            label.style.setProperty('--kokoot-variant-color', solidColor);

            let swatch = label.querySelector('.kokoot-variant-chip__image');
            if (!swatch) {
              swatch = document.createElement('span');
              swatch.className = 'kokoot-variant-chip__image';
              swatch.setAttribute('aria-hidden', 'true');
              input.insertAdjacentElement('afterend', swatch);
            }
            swatch.style.removeProperty('background-image');
            return;
          }
        }

        if (!image) {
          label.classList.add('kokoot-variant-chip--text');
          return;
        }

        label.classList.add('kokoot-variant-chip--media');
        label.style.setProperty('--kokoot-variant-image', `url("${image}")`);

        let swatch = label.querySelector('.kokoot-variant-chip__image');
        if (!swatch) {
          swatch = document.createElement('span');
          swatch.className = 'kokoot-variant-chip__image';
          swatch.setAttribute('aria-hidden', 'true');
          input.insertAdjacentElement('afterend', swatch);
        }
        swatch.style.backgroundImage = `url("${image}")`;
      });
    });
  }

  // Color -> Size dependent filtering: for every option after the first, show only values that actually
  // exist for the currently-selected earlier options; hide the rest (display:none, not just disabled).
  // If the current selection becomes invalid, auto-select the first available value for the new combo.
  function applyDependentOptions() {
    const { items } = parseVariantMedia();
    if (!items.length) return;

    const fieldsets = Array.from(document.querySelectorAll('.product-details .variant-option'))
      .filter((fs) => fs.querySelector('.variant-option__button-label') && fs.dataset.fieldsetIndex != null)
      .sort((a, b) => parseInt(a.dataset.fieldsetIndex, 10) - parseInt(b.dataset.fieldsetIndex, 10));
    if (fieldsets.length < 2) return; // single-option products need no cross-filtering

    // selected value per option position
    const selected = {};
    fieldsets.forEach((fs) => {
      const pos = parseInt(fs.dataset.fieldsetIndex, 10);
      const checked = fs.querySelector('.variant-option__button-label input:checked');
      if (checked) selected[pos] = valueOfLabel(checked.closest('.variant-option__button-label'));
    });

    fieldsets.forEach((fs) => {
      const pos = parseInt(fs.dataset.fieldsetIndex, 10);
      if (pos === 0) return; // first option is always fully shown

      const exists = new Set();
      const available = new Set();
      items.forEach((it) => {
        const opts = it.options || [];
        for (let q = 0; q < pos; q++) {
          if (selected[q] !== undefined && opts[q] !== selected[q]) return;
        }
        exists.add(opts[pos]);
        if (it.available) available.add(opts[pos]);
      });

      let checkedHidden = false;
      let firstAvailable = null;
      let firstVisible = null;

      fs.querySelectorAll('.variant-option__button-label').forEach((label) => {
        const value = valueOfLabel(label);
        const show = exists.has(value);
        if (show) {
          label.style.removeProperty('display');
          if (!firstVisible) firstVisible = label;
          if (!firstAvailable && available.has(value)) firstAvailable = label;
        } else {
          label.style.setProperty('display', 'none', 'important');
        }
        const input = label.querySelector('input[type="radio"]');
        if (input && input.checked && !show) checkedHidden = true;
      });

      // The current value is no longer valid for the new earlier-option selection -> auto-correct.
      if (checkedHidden && !autoSelectPending) {
        const target = (firstAvailable || firstVisible);
        const targetInput = target && target.querySelector('input[type="radio"]');
        if (targetInput) {
          autoSelectPending = true;
          if (autoSelectTimer) window.clearTimeout(autoSelectTimer);
          autoSelectTimer = window.setTimeout(() => { autoSelectPending = false; }, 1500);
          targetInput.click();
        }
      }
    });
  }

  function ensureRelatedFallbackImages() {
    document.querySelectorAll(`${RELATED_SELECTOR} product-card`).forEach((card) => {
      const featuredMediaUrl = card.getAttribute('data-featured-media-url');
      if (!featuredMediaUrl) return;

      const content = card.querySelector('.product-card__content') || card;
      const existingFallback = content.querySelector('.kokoot-related-card-fallback');
      if (existingFallback) {
        card.classList.add('kokoot-related-card--has-fallback');
        return;
      }

      const imageUrl = featuredMediaUrl.startsWith('//') ? `${location.protocol}${featuredMediaUrl}` : featuredMediaUrl;
      const fallback = document.createElement('a');
      fallback.className = 'kokoot-related-card-fallback';
      fallback.href = card.querySelector('a[href]')?.getAttribute('href') || '#';
      fallback.setAttribute('aria-hidden', 'true');
      fallback.tabIndex = -1;

      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      fallback.appendChild(image);

      content.prepend(fallback);
      card.classList.add('kokoot-related-card--has-fallback');
    });
  }

  function findGalleryContainers() {
    return Array.from(document.querySelectorAll('.product-information media-gallery slideshow-container'));
  }

  function gallerySlides(container) {
    const directSlides = Array.from(container.querySelectorAll('slideshow-slide.product-media-container'));
    if (directSlides.length) return directSlides;
    return Array.from(container.querySelectorAll('slideshow-slide'));
  }

  function activeSlideIndex(container, slides) {
    const selectors = [
      (slide) => slide.getAttribute('aria-hidden') === 'false',
      (slide) => slide.hasAttribute('aria-current'),
      (slide) => slide.classList.contains('is-active'),
    ];
    for (const matcher of selectors) {
      const index = slides.findIndex(matcher);
      if (index >= 0) return index;
    }

    const scroller = container.querySelector('slideshow-slides');
    if (scroller && scroller.clientWidth) {
      return Math.max(0, Math.min(slides.length - 1, Math.round(scroller.scrollLeft / scroller.clientWidth)));
    }
    return 0;
  }

  function showGalleryProgress(container) {
    const progress = container.querySelector(':scope > .kokoot-gallery-progress');
    if (!progress) return;
    progress.classList.add('is-visible');
    const previousTimer = galleryProgressTimers.get(container);
    if (previousTimer) window.clearTimeout(previousTimer);
    galleryProgressTimers.set(container, window.setTimeout(() => {
      progress.classList.remove('is-visible');
    }, 1600));
  }

  function updateGalleryProgress(container, reveal = false) {
    const slides = gallerySlides(container);
    const progress = container.querySelector(':scope > .kokoot-gallery-progress');
    if (!progress) return;
    const index = activeSlideIndex(container, slides);
    progress.querySelectorAll('.kokoot-gallery-progress__item').forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === index);
    });
    if (reveal) showGalleryProgress(container);
  }

  function ensureGalleryProgress() {
    findGalleryContainers().forEach((container) => {
      const slides = gallerySlides(container);
      let progress = container.querySelector(':scope > .kokoot-gallery-progress');
      if (slides.length < 2) {
        if (progress) progress.remove();
        return;
      }

      if (!progress) {
        progress = document.createElement('div');
        progress.className = 'kokoot-gallery-progress';
        progress.setAttribute('aria-hidden', 'true');
        container.appendChild(progress);

        const scroller = container.querySelector('slideshow-slides');
        if (scroller && !scroller.dataset.kokootProgressBound) {
          scroller.dataset.kokootProgressBound = 'true';
          scroller.addEventListener('scroll', () => updateGalleryProgress(container, true), { passive: true });
        }
        if (!container.dataset.kokootProgressBound) {
          container.dataset.kokootProgressBound = 'true';
          ['click', 'touchend', 'keyup'].forEach((eventName) => {
            container.addEventListener(eventName, () => window.setTimeout(() => updateGalleryProgress(container, true), 80), {
              passive: true,
            });
          });
        }
      }

      if (progress.children.length !== slides.length) {
        progress.innerHTML = '';
        slides.forEach(() => {
          const item = document.createElement('span');
          item.className = 'kokoot-gallery-progress__item';
          progress.appendChild(item);
        });
      }
      updateGalleryProgress(container);
    });
  }

  function normalizeAddToCartText() {
    document.querySelectorAll('.product-information .add-to-cart-text__content span')
      .forEach((node) => {
        if ((node.textContent || '').trim() === 'Add to cart') node.textContent = 'Add to Cart';
      });
  }

  // NOTE: rating + badge are placed on one row via pure CSS now (see kokoot-pdp css
  // .product-details:has(...) / sibling rules). No DOM move here = no layout shift / FOUC.

  const VC_THRESHOLD = 7; // collapse when MORE than 7 values (one row); show first row of 7 + dropdown

  function collapseVariantOptions() {
    document.querySelectorAll('.product-details .variant-option').forEach((fieldset) => {
      // Text options (Size etc.) are never collapsed into a 7-per-row grid — force them expanded so the
      // CSS-first collapse rule can't hide valid values, and drop any stray toggle.
      if (fieldset.classList.contains('kokoot-opt-text')) {
        fieldset.classList.remove('kokoot-vc', 'kokoot-vc--collapsed');
        fieldset.classList.add('kokoot-vc--expanded');
        const stray = fieldset.querySelector('.kokoot-vc-toggle');
        if (stray) stray.remove();
        return;
      }

      const labels = fieldset.querySelectorAll('.variant-option__button-label');
      const count = labels.length;

      if (count <= VC_THRESHOLD) {
        fieldset.classList.remove('kokoot-vc', 'kokoot-vc--collapsed', 'kokoot-vc--expanded');
        const stray = fieldset.querySelector('.kokoot-vc-toggle');
        if (stray) stray.remove();
        return;
      }

      fieldset.classList.add('kokoot-vc');
      if (!fieldset.classList.contains('kokoot-vc--collapsed') && !fieldset.classList.contains('kokoot-vc--expanded')) {
        fieldset.classList.add('kokoot-vc--collapsed');
      }

      let toggle = fieldset.querySelector('.kokoot-vc-toggle');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'kokoot-vc-toggle';
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const collapsed = fieldset.classList.toggle('kokoot-vc--collapsed');
          fieldset.classList.toggle('kokoot-vc--expanded', !collapsed);
          updateToggleLabel(fieldset, toggle);
        });
        fieldset.appendChild(toggle);
      } else if (toggle !== fieldset.lastElementChild) {
        fieldset.appendChild(toggle);
      }
      updateToggleLabel(fieldset, toggle, count);
    });
  }

  function updateToggleLabel(fieldset, toggle, count) {
    const total = count || fieldset.querySelectorAll('.variant-option__button-label').length;
    const collapsed = fieldset.classList.contains('kokoot-vc--collapsed');
    toggle.innerHTML = collapsed
      ? `Choose from ${total} styles <span class="kokoot-vc-toggle__car" aria-hidden="true">&#9662;</span>`
      : `Show less <span class="kokoot-vc-toggle__car" aria-hidden="true">&#9652;</span>`;
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  function run() {
    runQueued = false;
    // Each step is independent: a failure in one must not block the others or break the page.
    try { decorateVariantButtons(); } catch (e) { console.warn('[kokoot] decorate failed', e); }
    try { applyDependentOptions(); } catch (e) { console.warn('[kokoot] dependent options failed', e); }
    try { collapseVariantOptions(); } catch (e) { console.warn('[kokoot] collapse failed', e); }
    try { ensureRelatedFallbackImages(); } catch (e) { console.warn('[kokoot] related fallback failed', e); }
    try { ensureGalleryProgress(); } catch (e) { console.warn('[kokoot] gallery progress failed', e); }
    try { normalizeAddToCartText(); } catch (e) { console.warn('[kokoot] add-to-cart text failed', e); }
  }

  function runFromVariantUpdate() {
    // A fresh variant:update means a selection actually took effect — clear the auto-select guard.
    autoSelectPending = false;
    run();
  }

  function scheduleRun(delay = 0) {
    window.setTimeout(() => {
      if (runQueued) return;
      runQueued = true;
      window.requestAnimationFrame(run);
    }, delay);
  }

  function scheduleRunBurst() {
    [0, 60, 180, 420, 900].forEach(scheduleRun);
  }

  function isKokootInjectedNode(node) {
    return (
      node instanceof Element &&
      (node.matches('.kokoot-variant-chip__image, .kokoot-related-card-fallback, .kokoot-vc-toggle, .kokoot-gallery-progress') ||
        Boolean(node.closest('.kokoot-variant-chip__image, .kokoot-related-card-fallback, .kokoot-vc-toggle, .kokoot-gallery-progress')))
    );
  }

  function watchProductRenders() {
    const root = document.querySelector('main') || document.body;
    if (!root) return;

    const observer = new MutationObserver((mutations) => {
      const shouldRefresh = mutations.some((mutation) => {
        const nodes = [...mutation.addedNodes, ...mutation.removedNodes].filter((node) => node instanceof Element);
        if (!nodes.length) return false;
        if (nodes.every(isKokootInjectedNode)) return false;

        return nodes.some((node) => {
          return (
            node.matches(VARIANT_LABEL_SELECTOR) ||
            node.matches('.product-details, .variant-option, product-card') ||
            Boolean(node.querySelector?.(`${VARIANT_LABEL_SELECTOR}, .product-details, .variant-option, product-card`)) ||
            Boolean(node.closest?.('.product-details, [id$="__product_list_related"]'))
          );
        });
      });

      if (shouldRefresh) {
        scheduleRunBurst();
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        scheduleRunBurst();
        watchProductRenders();
      },
      { once: true }
    );
  } else {
    scheduleRunBurst();
    watchProductRenders();
  }

  // Tinker re-renders (morph) the <variant-picker> from freshly-fetched server HTML on every variant
  // change, which strips the kokoot swatch images + "Choose from N styles" toggle (the server HTML has
  // none of them). Tinker then dispatches 'variant:update' (bubbles to document) SYNCHRONOUSLY right
  // after the morph and BEFORE the browser paints. Re-decorating here — synchronously, not via the
  // deferred setTimeout burst — closes the gap that previously made the variant/text area flash.
  ['variant:update', 'variant:selected'].forEach((eventName) => {
    document.addEventListener(eventName, runFromVariantUpdate);
  });

  ['shopify:section:load', 'shopify:section:select', 'variant:change', 'product:variant-change'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleRunBurst);
  });

  ['pointerdown', 'click', 'change', 'input'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.target instanceof Element && event.target.closest(VARIANT_INTERACTION_SELECTOR)) {
        scheduleRunBurst();
      }
    });
  });
})();
